// extracted by mini-css-extract-plugin
export var baseGrid = "grid-module--baseGrid--ce3ba";
export var grid = "grid-module--grid--1de98";